import { inherits as _inherits, classCallCheck as _classCallCheck, createClass as _createClass, createSuper as _createSuper } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { pixelsFor } from './index.js';
import { CachedLateValue as CachedLateValue$1 } from './CachedLateValue.js';

/** Compute and return the total item width (that is, including spacing). This is potenially
    expensive, so we use this container to cache its values. */

var CachedDOMMeasurement = /*#__PURE__*/function (_CachedLateValue) {
  _inherits(CachedDOMMeasurement, _CachedLateValue);

  var _super = _createSuper(CachedDOMMeasurement);

  function CachedDOMMeasurement(element) {
    var _this;

    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, CachedDOMMeasurement);

    _this = _super.call(this);
    _this.element = element;
    _this.fallbackValue = fallbackValue;
    _this.cssProperties = [];
    _this.offsetProperties = [];
    return _this;
  }

  _createClass(CachedDOMMeasurement, [{
    key: "applyFallback",
    value: function applyFallback(value) {
      return Number.isFinite(value) ? value : this.fallbackValue;
    }
  }, {
    key: "cssSum",
    value: function cssSum(el) {
      var style = getComputedStyle(el);
      return this.cssProperties.reduce(function (total, p) {
        return total + pixelsFor(p, style);
      }, 0);
    }
  }, {
    key: "offsetSum",
    value: function offsetSum(el) {
      return this.offsetProperties.reduce(function (total, p) {
        return total + el[p];
      }, 0);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var el = this.element();
      if (!el) return 0;
      return this.applyFallback(this.cssSum(el) + this.offsetSum(el));
    }
  }]);

  return CachedDOMMeasurement;
}(CachedLateValue$1);

export { CachedDOMMeasurement };
